import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconTransmissionInProgress = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? ''
  size = size ?? 60
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 40 40' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39ZM20 37.1C10.5559 37.1 2.9 29.4441 2.9 20C2.9 10.5559 10.5559 2.9 20 2.9C29.4441 2.9 37.1 10.5559 37.1 20C37.1 29.4441 29.4441 37.1 20 37.1Z'
        fill='#004791'
      />
      <mask
        id='mask0_1507_42542'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='8'
        y='8'
        width='24'
        height='24'
      >
        <rect x='8' y='8' width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_1507_42542)'>
        <path
          d='M13.3 28.5008C12.8 28.5008 12.375 28.3258 12.025 27.9758C11.675 27.6258 11.5 27.2008 11.5 26.7008V13.3008C11.5 12.8008 11.675 12.3758 12.025 12.0258C12.375 11.6758 12.8 11.5008 13.3 11.5008H17.725C17.8583 11.0174 18.1373 10.6131 18.562 10.2878C18.9873 9.96311 19.4667 9.80078 20 9.80078C20.55 9.80078 21.0377 9.96311 21.463 10.2878C21.8877 10.6131 22.1667 11.0174 22.3 11.5008H26.7C27.2 11.5008 27.625 11.6758 27.975 12.0258C28.325 12.3758 28.5 12.8008 28.5 13.3008V19.3508H27V13.3008C27 13.2174 26.971 13.1468 26.913 13.0888C26.8543 13.0301 26.7833 13.0008 26.7 13.0008H24.5V13.8008C24.5 14.3008 24.325 14.7301 23.975 15.0888C23.625 15.4468 23.2 15.6258 22.7 15.6258H17.3C16.8 15.6258 16.375 15.4468 16.025 15.0888C15.675 14.7301 15.5 14.3008 15.5 13.8008V13.0008H13.3C13.2167 13.0008 13.146 13.0301 13.088 13.0888C13.0293 13.1468 13 13.2174 13 13.3008V26.7008C13 26.7841 13.0293 26.8551 13.088 26.9138C13.146 26.9718 13.2167 27.0008 13.3 27.0008H18.25V28.5008H13.3ZM25.475 28.1008C25.325 27.9508 25.25 27.7758 25.25 27.5758C25.25 27.3758 25.325 27.2008 25.475 27.0508L26.775 25.7508H21C20.7833 25.7508 20.6043 25.6801 20.463 25.5388C20.321 25.3968 20.25 25.2174 20.25 25.0008C20.25 24.7841 20.321 24.6048 20.463 24.4628C20.6043 24.3214 20.7833 24.2508 21 24.2508H26.775L25.45 22.9258C25.3167 22.7924 25.25 22.6258 25.25 22.4258C25.25 22.2258 25.325 22.0424 25.475 21.8758C25.625 21.7424 25.8 21.6758 26 21.6758C26.2 21.6758 26.375 21.7424 26.525 21.8758L29 24.3758C29.1 24.4591 29.171 24.5551 29.213 24.6638C29.2543 24.7718 29.275 24.8841 29.275 25.0008C29.275 25.1174 29.2543 25.2298 29.213 25.3378C29.171 25.4464 29.1 25.5424 29 25.6258L26.525 28.1258C26.375 28.2758 26.2 28.3464 26 28.3378C25.8 28.3298 25.625 28.2508 25.475 28.1008ZM20 13.1258C20.25 13.1258 20.4623 13.0381 20.637 12.8628C20.8123 12.6881 20.9 12.4674 20.9 12.2008C20.9 11.9508 20.8123 11.7381 20.637 11.5628C20.4623 11.3881 20.25 11.3008 20 11.3008C19.75 11.3008 19.5377 11.3881 19.363 11.5628C19.1877 11.7381 19.1 11.9591 19.1 12.2258C19.1 12.4758 19.1877 12.6881 19.363 12.8628C19.5377 13.0381 19.75 13.1258 20 13.1258Z'
          fill='white'
        />
      </g>
    </Icon>
  )
}

IconTransmissionInProgress.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconTransmissionInProgress
